import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getFunnelAuditScreenshot, getPublicFunnelAuditScreenshot } from '@/api/funnel-audits';

interface PrivateScreenshotProps {
  id: string;
  alt: string;
  className?: string;
  publicToken?: string;
}

export function PrivateScreenshot({ id, alt, className = '', publicToken }: PrivateScreenshotProps) {
  const [src, setSrc] = useState('');
  const query = useQuery({
    queryKey: ['funnel-audit-screenshot', publicToken ?? 'admin', id],
    queryFn: () => publicToken
      ? getPublicFunnelAuditScreenshot(publicToken, id)
      : getFunnelAuditScreenshot(id),
    staleTime: 10 * 60 * 1000,
  });

  useEffect(() => {
    if (!query.data) return;
    const next = URL.createObjectURL(query.data);
    setSrc(next);
    return () => URL.revokeObjectURL(next);
  }, [query.data]);

  if (query.isError) {
    return <div className={`flex items-center justify-center bg-danger-soft text-danger text-xs ${className}`}>Failed to load</div>;
  }
  if (!src) {
    return <div className={`animate-pulse bg-surface-muted ${className}`} aria-label={`Loading ${alt}`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
